import { createFileRoute, notFound } from "@tanstack/react-router";
import { MarketingIdeaPage } from "../components/marketing/MarketingIdeaPage";
import { findIdea, ideaPage, withDetails } from "../marketing-content/automationIdeas";
import { contentHead } from "../marketing-content/head";
import { loadIdeaDetails } from "../marketing-content/loadIdeaDetails";

export const Route = createFileRoute("/workflows_/$slug")({
  loader: async ({ params }) => {
    const idea = findIdea(params.slug);
    if (!idea) throw notFound();
    return withDetails(idea, await loadIdeaDetails(idea.id));
  },
  head: ({ loaderData }) => contentHead(loaderData && ideaPage(loaderData)),
  component: IdeaRoute,
});

function IdeaRoute() {
  return <MarketingIdeaPage idea={Route.useLoaderData()} />;
}
